<aionz-purchase-request-activity-panel
  [purchaseId]="purchaseIdAtual()"
  [panelTitle]="'Atividade da solicitação'"
  [panelSubtitle]="'#' + purchaseIdAtual()">
  <div class="approval-detail flex-col">
    <header class="approval-header">
      <div class="approval-title-block">
        <div class="approval-title-row">
          <button
            mat-icon-button
            type="button"
            aria-label="Voltar para o quadro"
            class="back-button"
            (click)="handleGoBack()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <h1 class="approval-title">{{ data()?.title || 'Solicitação' }}</h1>
          <button
            mat-icon-button
            type="button"
            class="activity-icon-button"
            aionzTooltip="Atividade da solicitação"
            mode="message"
            aria-label="Abrir a atividade da solicitação"
            (click)="openActivityTab()">
            <mat-icon aria-hidden="true">timeline</mat-icon>
          </button>
        </div>

        @if (data(); as purchase) {
          @if (purchase.description) {
            <span class="approval-description">{{ purchase.description }}</span>
          }

          <div class="approval-meta">
            <mat-basic-chip class="custom-chip custom-id-chip">#{{ purchase.id }}</mat-basic-chip>
            <aionz-purchase-request-status [status]="status" />

            <div class="requested-at">
              <mat-icon
                class="requested-at-icon"
                aria-hidden="true"
                >calendar_month</mat-icon
              >
              <span>Cotação iniciada em: {{ purchase.requestedAt | date: 'dd/MM/yy' }}</span>
            </div>

            @if (deliveryBranchesSummary().branches.length > 0) {
              <button
                type="button"
                class="custom-chip info-chip"
                [aionzTooltipComponent]="branchesTooltipComponent"
                [aionzTooltipData]="deliveryBranchesSummary()"
                aionzTooltipPosition="below"
                aionzTooltipClass="branches-tooltip"
                mode="message"
                [attr.aria-label]="deliveryBranchesLabel()">
                <mat-icon aria-hidden="true">business</mat-icon>
                {{ deliveryBranchesLabel() }}
              </button>
            }

            @if (activityPanel().commentsCount() !== null) {
              @let commentsCount = activityPanel().commentsCount() ?? 0;
              @let comments =
                commentsCount === 0
                  ? 'Sem comentários'
                  : commentsCount === 1
                    ? '1 comentário'
                    : commentsCount + ' comentários';
              <button
                type="button"
                class="custom-chip info-chip comments-chip"
                [aionzTooltip]="commentsCount === 0 ? 'Escrever o primeiro comentário' : 'Abrir os comentários da solicitação'"
                mode="message"
                [attr.aria-label]="'Abrir os comentários da solicitação, ' + comments"
                (click)="openCommentsTab()">
                <mat-icon aria-hidden="true">forum</mat-icon>
                {{ comments }}
              </button>
            }
          </div>
        }
      </div>

      <button
        mat-flat-button
        type="button"
        [disabled]="!canApprove()"
        (click)="approve()">
        <mat-icon aria-hidden="true">task_alt</mat-icon>
        Aprovar
      </button>
    </header>

    @switch (loadState()) {
      @case (LoadState.LOADED) {
        @let revisao = review();
        @if (!revisao || revisao.suppliers.length === 0) {
          <aionz-empty-content
            icon="rule"
            title="Nada aguardando aprovação"
            description="Esta solicitação não tem cotações aguardando aprovação. Ela pode já ter sido aprovada ou cancelada." />
        } @else {
          <!-- Resumo: o mesmo quadro da revisão do mapa. Mapa: o mapa de cotação só para leitura,
               carregado quando a aba é aberta (como os anexos nas outras telas). -->
          <mat-tab-group
            class="approval-tabs"
            [mat-stretch-tabs]="false">
            <mat-tab>
              <ng-template mat-tab-label>
                <div class="flex-row items-center gap-8">
                  <mat-icon aria-hidden="true">fact_check</mat-icon>
                  <span>Resumo</span>
                </div>
              </ng-template>
              <ng-template matTabContent>
                <aionz-approval-review
                  class="approval-review"
                  modo="aprovacao"
                  [review]="revisao" />
              </ng-template>
            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                <div class="flex-row items-center gap-8">
                  <mat-icon aria-hidden="true">table_view</mat-icon>
                  <span>Mapa de cotação</span>
                </div>
              </ng-template>
              <ng-template matTabContent>
                @if (mapaLeitura(); as mapa) {
                  <div class="approval-map">
                    <aionz-quotation-map-board
                      [data]="mapa"
                      [readonly]="true" />
                  </div>
                }
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        }
      }
      @case (LoadState.ERROR) {
        <aionz-empty-content
          icon="error_outline"
          title="Não foi possível carregar a solicitação"
          description="Volte ao quadro e tente abrir de novo." />
      }
      @default {
        <div
          class="approval-loading"
          role="status"
          aria-label="Carregando a solicitação">
          <div class="skeleton skeleton-summary"></div>
          <div class="skeleton skeleton-table"></div>
        </div>
      }
    }
  </div>
</aionz-purchase-request-activity-panel>
